import {
    Alert,
    AlertDescription,
    AlertTitle,
    Image,
    useToast,
    VStack,
    Box
} from "@chakra-ui/react";
import React from "react";
import Colors from "../../assets/colors/Colors";
import warningImage from "../../assets/images/danger.svg";
import errorImage from "../../assets/images/octicon_x-16.svg";
import SuccessImage from "../../assets/images/typcn_tick.svg";
import * as Constants from "../../constants/Constants";

const GrubTostMessage = (props) => {
    const toast = useToast();

    const addToast = (newRes) => {
        if(newRes?.isBottomToast) {
            toast({
                position: newRes?.position ? newRes?.position : "bottom",
                description: newRes.alertDescription,
                status: newRes.alertStatus,
                duration: newRes?.duration ? newRes?.duration : 2000,
                fontSize: {
                    base: "0.20rem",
                    md: "0.94rem",
                },  
              })
        } else {
            toast({
                position: newRes?.position ? newRes?.position : Constants.TOAST_POSITION,
                duration: newRes?.duration ? newRes?.duration : 2000,
                render: () => (
                <Alert
                    status={newRes.alertStatus}
                    variant="left-accent"
                    width={{ base: "90%", sm: "24.68rem" }}
                    maxWidth="24.68rem"
                    minWidth={{ base: "280px", sm: "320px" }}
                    padding={{ base: "0.75rem", sm: "1rem" }}
                    bg={
                        newRes.alertStatus == Constants.TOAST_TYPE_SUCESS
                            ? Colors.loginAuthBackground
                            : newRes.alertStatus == Constants.TOAST_TYPE_WARNING
                                ? Colors.toastWarning
                                : Colors.loginAuthBackground
                    }
                    style={{
                        boxShadow: "0px 4px 30px 0px" + Colors.toastBoxShadow,
                    }}
                    display="flex"
                    alignItems="flex-start"
                    borderRadius="8px"
                    margin={{ base: "0 auto", sm: "0" }}
                >
                    <Box
                        flexShrink={0}
                        marginRight={{ base: "0.5rem", sm: "0.75rem" }}
                    >
                        <Image
                            boxSize={{ base: "1.75rem", sm: "2.5rem" }}
                            src={
                                newRes.alertStatus == Constants.TOAST_TYPE_SUCESS
                                    ? SuccessImage
                                    : newRes.alertStatus == Constants.TOAST_TYPE_WARNING
                                        ? warningImage
                                        : errorImage
                            }
                            p={{ base: "0.25rem", sm: "0.38rem" }}
                        />
                    </Box>
                    <VStack
                        alignItems="flex-start"
                        spacing={{ base: "0.25rem", sm: "0.5rem" }}
                        flex="1"
                    >
                        <AlertTitle
                            fontSize={{ base: "0.875rem", sm: "1.125rem" }}
                            fontWeight={500}
                            color={Colors.posTextInfo}
                            lineHeight="1.2"
                            margin="0"
                        >
                            {newRes.alertTitle}
                        </AlertTitle>
                        <AlertDescription
                          fontSize={{ base: "0.75rem", sm: "0.938rem" }}
                          fontWeight={300}
                          color={Colors.posTextInfo}
                          lineHeight="1.4"
                          margin="0"
                          wordBreak="break-word"
                        >
                          {newRes.alertDescription}
                      </AlertDescription>
                    </VStack>
                </Alert>
            ),
        });
        }
    };
    return { addToast };
};

export default GrubTostMessage;
  